import React from 'react';

import { LinearProgress } from 'material-ui';
import { FormattedMessage } from 'react-intl';

const styles = {
  loadingContainer: {
    padding: 12,
    width: 'calc(100% - 24px)',
    height: 'calc(100% - 24px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  progress: {
    width: '70%',
  },
  text: {
    fontSize: 24,
    marginBottom: 12,
  },
};

const TLoading = () => (
  <div style={styles.loadingContainer}>
    <span style={styles.text}>
      <FormattedMessage id="tile.loading" />
    </span>
    <LinearProgress style={styles.progress} mode="indeterminate" />
  </div>
);

export default TLoading;



// WEBPACK FOOTER //
// ./src/containers/tiles/TLoading.js